import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

// Set user availability status
export const setAvailabilityStatus = createAsyncThunk(
    "availability/setStatus",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await api.create("/api/availability/status", data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// Get current user's availability status
export const getAvailabilityStatus = createAsyncThunk(
    "availability/getStatus",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get("/api/availability/status");
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// Get all users' availability
export const getAllUsersAvailability = createAsyncThunk(
    "availability/getAll",
    async (filters: any = {}, { rejectWithValue }) => {
        try {
            const params = filters || {};
            const response = await api.get("/api/availability/all", params);
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// Get upcoming meetings
export const getUpcomingMeetings = createAsyncThunk(
    "availability/getUpcomingMeetings",
    async (limit: number = 5, { rejectWithValue }) => {
        try {
            const response = await api.get("/api/availability/upcoming-meetings", { limit });
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

